module.exports = __webpack_public_path__ + "img/apple.47131535.png";